import { buildWebsiteUrl } from '@repo/utils/url';

import { PageType } from '../../page/types';
import { pageTypes } from '../../pageTypes';

import { EnrichedCategoriesInfoItem, ToolsType } from './types';

// TODO: ideally we should have a type with all Page keys
//  and use this type as a value in record instead of string
export const enrichToolsPages: Partial<
  Record<ToolsType, (PageType | string)[]>
> = {
  ['Mockups']: [PageType.MockupParentPage, PageType.MockupChildPage],
  ['AIWriting']: [
    PageType.AiWritingToolParentPage,
    PageType.AiWritingToolChildPage,
  ],
  ['AIUseCaseGenerators']: [
    pageTypes.AI_USE_CASE_GENERATOR_PAGE_COLLECTION_TYPE,
  ],
  ['AITools']: [
    pageTypes.AI_IMAGE_GENERATOR_COLLECTION_TYPE,
    pageTypes.AI_VECTOR_GENERATOR_COLLECTION_TYPE,
    pageTypes.VECTORIZER_COLLECTION_TYPE,
    pageTypes.BACKGROUND_REMOVER_MICRO_APP,
  ],
};

export const extraTools: Partial<
  Record<ToolsType, EnrichedCategoriesInfoItem[]>
> = {
  ['AITools']: [
    {
      title: 'AI Background Generator',
      url: buildWebsiteUrl('/tools/background-generator'),
      image: {
        url: '/images/tools/ai-background-generator.png',
        alt: 'AI Background Generator',
        height: 324,
        width: 432,
        filename: 'ai-background-generator.png',
      },
    },
  ],
  ['SvgTools']: [
    {
      title: 'SVG Converter',
      url: buildWebsiteUrl('/tools/svg-converter'),
      image: {
        url: '/images/tools/svg-converter.png',
        alt: 'SVG Converter',
        height: 324,
        width: 432,
        filename: 'ai-background-generator.png',
      },
    },
    {
      title: 'JPG to SVG Converter',
      url: buildWebsiteUrl('/tools/jpg-to-svg'),
      image: {
        url: '/images/tools/jpg-to-svg-converter.png',
        alt: 'JPG to SVG Converter',
        height: 324,
        width: 432,
        filename: 'ai-image-vectorizer.png',
      },
    },
    {
      title: 'PNG to SVG Converter',
      url: buildWebsiteUrl('/tools/png-to-svg'),
      image: {
        url: '/images/tools/png-to-svg-converter.png',
        alt: 'PNG to SVG Converter',
        height: 324,
        width: 432,
        filename: 'ai-background-generator.png',
      },
    },
  ],
};
